import { useLocation } from 'react-router-dom';
import queryString from 'query-string';

export function useRouterQuery(): Record<string, any> {
  const params = useLocation().search;
  return queryString.parse(params);
}
